import React, { useState, useEffect } from 'react';

const LocationMap = ({ 
  address = "北京市朝阳区蟹岛路1号", 
  englishAddress = "Hall 2, Crab Island Convention Center, Chaoyang, Beijing, China",
  venueName = "蟹岛国际会展中心2号馆",
  mapUrl = "https://j.map.baidu.com/a6/i2c",
  enableAfter = null // Date when the map becomes clickable
}) => {
  const [isEnabled, setIsEnabled] = useState(true);

  useEffect(() => {
    if (enableAfter) {
      const checkEnabled = () => {
        const now = new Date();
        const enableDate = new Date(enableAfter);
        setIsEnabled(now >= enableDate);
      };
      
      checkEnabled();
      // Check every minute if we're close to the enable time
      const interval = setInterval(checkEnabled, 60000);
      
      return () => clearInterval(interval);
    }
  }, [enableAfter]);

  const handleLocationClick = () => {
    if (isEnabled) {
      window.open(mapUrl, '_blank');
    }
  };

  return (
    <div 
      className={`transform transition-all duration-200 ${
        isEnabled ? 'cursor-pointer hover:scale-105 group' : ''
      }`}
      onClick={isEnabled ? handleLocationClick : undefined}
      role={isEnabled ? "button" : undefined}
      tabIndex={isEnabled ? 0 : undefined}
      onKeyPress={isEnabled ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleLocationClick();
        }
      } : undefined}
    >
      <div className={`text-4xl mb-4 ${isEnabled ? 'group-hover:animate-bounce' : ''}`}>
        📍
      </div>
      <h3 className="text-2xl font-chinese font-bold text-chinese-red mb-2 group-hover:text-chinese-dark transition-colors">
        婚礼地点
      </h3>
      <p className="text-lg text-gray-700 font-semibold">{venueName}</p>
      <p className="text-md text-gray-600">{englishAddress}</p>
      <p className="text-sm text-gray-500 mt-2">{address}</p>
      
      {/* Navigation hint - only show when enabled */}
      {isEnabled && (
        <>
          <div className="mt-3 p-2 bg-chinese-red/10 rounded-lg border border-chinese-red/20 group-hover:bg-chinese-red/20 transition-colors">
            <p className="text-sm font-medium text-chinese-red group-hover:text-chinese-dark transition-colors">
              🗺️ 点击查看地图
            </p>
            <p className="text-xs text-gray-600 mt-1">
              Click to view map
            </p>
          </div>
          
          {/* Accessibility hint */}
          <div className="sr-only">
            Press Enter or Space to open location in maps application
          </div>
        </>
      )}
    </div>
  );
};

export default LocationMap;
